import { useState, useEffect } from 'react';
import { replacePath, web3Navigate } from '@web3/utils';
import { checkSupport } from '../../utils/constants';
import { useLocale } from '../../store/i18nMessage';
import { useScreen } from '../../store/screen';
import styles from './index.module.scss';
import cls from 'clsx';
/**
 *
 * @param { string }   tabName 按钮展示名称
 * @param { string }   link    点击按钮后跳转的链接
 * @param { string }   symbol  1. 用于与当前路径进行匹配当前需要高亮按钮 2. 用于匹配剔除默认列表中的某些项
 * @param { object }   reportData 按钮点击需要额外上报的数据
 * @param { boolean }  isBlank  点击后是否需要重新打开一个新窗口
 * @param { boolean }  hidden  特定条件下隐藏
 *
 */
interface Item {
  tabName: string;
  link: string;
  symbol: string;
  subSymbol?: string;
  reportData?: Record<string, string>;
  isBlank?: boolean;
  hidden?: boolean;
}
/**
 *
 * @param { string }   reportEventName 按钮点击上报事件，默认为$webclick
 * @param { Item[] }   defaultMenus 展示的二级列表，默认为Earn二级列表
 * @param { string[] } excludeItems 剔除默认列表中的某些项，以symbol字段进行校验
 * @param { Item[] }   addItems 添加额外item
 *
 */
interface Props {
  reportEventName?: string;
  defaultMenus?: Array<Item>;
  excludeItems?: Array<string>;
  addItems?: Array<Item>;
}

export const Web3SecondHeader = (props: Props) => {
  const { t, locale, messages } = useLocale();
  const [list, setList] = useState([] as Array<Item>);
  const currentPathname = typeof window !== 'undefined' ? window.location.pathname : '';
  const { reportEventName = '$webclick', defaultMenus = [], excludeItems = [], addItems = [] } = props;
  const screen = useScreen();

  useEffect(() => {
    let menus = defaultMenus.length
      ? defaultMenus
      : [
          {
            hidden: !checkSupport(locale, 'airdrop'),
            link: replacePath('/web3/airdrop'),
            tabName: t('airdropArcade'),
            symbol: 'airdrop',
            reportData: {
              page_name: 'EarnWeb_homepage',
              button_name: 'Tab_Airdropacade',
            },
          },
          {
            hidden: !checkSupport(locale, 'staking'),
            link: replacePath('/web3/staking'),
            tabName: t('staking'),
            symbol: 'staking',
            reportData: {
              page_name: 'EarnWeb_homepage',
              button_name: 'Tab_Web3Earn',
            },
          },
          {
            hidden: false,
            link: replacePath('/web3/staking/BybitSOL'),
            tabName: 'Bybit Staked SOL（bbSOL）',
            symbol: 'BybitSOL',
            reportData: {
              page_name: 'EarnWeb_homepage',
              button_name: 'Tab_Web3EarnBybitSOL',
            },
          },
          // {
          //   hidden: !checkSupport(locale, 'points'),
          //   link: replacePath('/web3/points'),
          //   tabName: 'Web3 Points',
          //   symbol: 'points',
          //   subSymbol: 'upcoming',
          //   reportData: {
          //     page_name: 'EarnWeb_homepage',
          //     button_name: 'Tab_Web3Points',
          //   },
          // },
        ];

    menus = menus.filter((v) => {
      return !v.hidden && !excludeItems.includes(v.symbol);
    });

    setList([...menus, ...addItems]);
  }, [locale, messages]);

  if (screen.md) return null;

  return (
    <div className={styles.contianer}>
      {list.map((item) => {
        return (
          <a
            key={item.symbol}
            className={cls(
              styles.item,
              (currentPathname.endsWith(item.symbol) || currentPathname.endsWith(item.subSymbol as string)) && styles.active,
            )}
            rel="noreferrer"
            href={item.link}
            target={item.isBlank ? '_blank' : ''}
            onClick={(e) => {
              e.preventDefault();
              web3Navigate(item.link);
            }}
            data-spm-even={reportEventName}
            data-spm-data={JSON.stringify(item.reportData ?? {})}
          >
            {item.tabName}
          </a>
        );
      })}
    </div>
  );
};
